// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-Dg9yp","root":"root-B-VNZ"};